/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_StatusInputs */

const en_wb_sales_status = /** @type {(inputs: Wb_Sales_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sent`)
};

const lv_wb_sales_status = /** @type {(inputs: Wb_Sales_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nav nosūtīts`)
};

/**
* | output |
* | --- |
* | "Not sent" |
*
* @param {Wb_Sales_StatusInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_status = /** @type {((inputs?: Wb_Sales_StatusInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_StatusInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_status(inputs)
	return en_wb_sales_status(inputs)
});